import { getRandomId } from "client/utils/getRandomId";
import type { MemeTemplateSettings } from "types/meme";
import type { TextBox } from "../types";
import { getInitialTextBoxSettings } from "./getInitialTextBoxSettings";

export const getDefaultTextBoxes = (
    settings: MemeTemplateSettings,
    { xRatio, yRatio }: { xRatio: number; yRatio: number },
) => {
    const MAX_HEIGHT = 100;
    const width = Math.max(settings.width * xRatio * 0.9, 200);
    const left = (settings.width * xRatio - width) / 2;
    const textBoxes: TextBox[] = [
        {
            ...getInitialTextBoxSettings(
                {
                    width,
                    height: Math.min(settings.height * xRatio * 0.9, MAX_HEIGHT),
                    top: 20,
                    left,
                    rotation: 0,
                    fontColor: "black",
                    verticalAlign: "middle",
                    textAlign: "center",
                    forceCaps: true,
                    font: "Impact",
                },
                getRandomId(),
            ),
            zIndex: 0,
        },
    ];
    if (settings.height * yRatio > MAX_HEIGHT * 3) {
        textBoxes.push({
            ...getInitialTextBoxSettings(
                {
                    width,
                    height: MAX_HEIGHT,
                    top: settings.height * yRatio - MAX_HEIGHT - 20,
                    left,
                    rotation: 0,
                    fontColor: "black",
                    verticalAlign: "middle",
                    textAlign: "center",
                    forceCaps: true,
                    font: "Impact",
                },
                getRandomId(),
            ),
            zIndex: 1,
        });
    }
    return textBoxes;
};
